export var ElasticsearchSubjects;
(function (ElasticsearchSubjects) {
    ElasticsearchSubjects["MultiFilter"] = "elasticsearch-multi-filter";
})(ElasticsearchSubjects || (ElasticsearchSubjects = {}));
export var ElasticsearchFieldType;
(function (ElasticsearchFieldType) {
    ElasticsearchFieldType["Number"] = "number";
    ElasticsearchFieldType["Boolean"] = "boolean";
    ElasticsearchFieldType["Date"] = "date";
    ElasticsearchFieldType["IP"] = "ip";
    ElasticsearchFieldType["Object"] = "object";
    ElasticsearchFieldType["String"] = "string";
    ElasticsearchFieldType["Lucene"] = "lucene";
})(ElasticsearchFieldType || (ElasticsearchFieldType = {}));
//# sourceMappingURL=elasticsearch.enum.js.map